import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { ReportItem } from './PdfImages';

interface SortableImageProps {
  id: string;
  report: ReportItem;
}

export const SortableImage = ({ id, report }: SortableImageProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners} className="relative">
      <iframe
        src={report.image}
        style={{
          height: '100%',
          width: '100%',
          border: 'none',
          pointerEvents: 'none', // Prevents iframe from interfering with drag
        }}
      />
    </div>
  );
}
